var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoseGold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1060_683",
    transform: "scale(0.025)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1060_683",
    width: 40,
    height: 40,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAAAsSAAALEgHS3X78AAAC0UlEQVRYhc2ZXW7TQBSFz/VLEVXAohtoFkBlCYSKQMRREX0rIEAC8QQsIOwgyg6SBRSeECD+Am9UreIifgoCyYIFNBsoCg1F6tNFd2K7ztR2axLisaxMbM/4fjl37PgeE/5h+fPtzSxALggVgBwCHFBwqqClQesD5IOwDpB3ZG6xmzdaLsCdr69dADUCXRmMJIQtxeA0yKgfgdoAWlNzi95YAXe+vHJBVAfgRsFjcDkh5cMDqDF18tKBoJmAvz+/tEGoA3Q/MfhokLLdBCCgvdyA/Y0XNhE6Mscyg48O6QOopkEmAvY3njuAgrPpMMFHh+wFkP6BgP1Pz2wAmyCywy4ThCzrSlrxje2PT21m7gCwwRzs5eArq1VtqyY4HrQcO57ZL3bewRr1F0E6uz9W7FRAsFwQ7LB20glCytSqx5GiFG9/eOIG824vRVp6JpjuangLihRk5nr8Vw1UK0zJSEUF+Ov9Y1HP1QcUCOnufn/r7inIXEsbUBgkUFPJ7r17NAvCJiF7fhQxJwEqWwC7MerUX1WEksImKa5o0poEWbHA7MQHGgbpWCwPm9pAgyAdURCsBTcJMrzNGAtpxXeYCGlB22EapKUHNw3SAsM3GNKXfxI/KbghkAIoRXVycAMg1yXFXlbwgiE968TCnS7AbQMh20dPLXWtoGtLz78BkC2ED6wzC3fl+d8zCNKbPn15uCYBc0PLf5GQjRArApy5eM8Dc9MAyOb0mauRqTRcFwMNMPsFQso9OVIPSdbH1urykPWh1xN67SJtWHlk9TtEjdOTGqQ0fy3d+sAg1crIAXNvgkqqmDpcImAAKWkuTyjdKlZp/vo+ZysVUFPyf144TYCrpbM38huY8WVrdTmygMc0Jz0iahw7d3M0C3gf6NoDl1TFP2yi54Bsg6h1/Pyt8Zro+vJz7aG4EeKdqNcQIDgpkD5IWbzqNYR94Xa+1xAA/gLeROcXy17JOwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoseGold);
export default __webpack_public_path__ + "static/media/rose-gold.fddebf5ef724a5b0a422b69f19dea811.svg";
export { ForwardRef as ReactComponent };